export const isOpenResortModalSelector = (state) =>
  state.modals.isResortModalOpen;

export const isOpenDrawInstrumentsSelector = (state) =>
  state.modals.isDrawInstrumentsOpen;